import Vue from 'vue';
import accounting from 'accounting';

Vue.filter('currency', (value) => {
    if (!value) return '0';
    return accounting.formatMoney(value);
});
